import styled from 'styled-components'

export const FileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const HiddenFileInput = styled.input`
  display: none;
`

export const StyledFileLabel = styled.label`
  display: inline-block;
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ disabled, theme }) => (disabled ? 'transparent' : theme.colors.backgroundLite)};
  border: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
  text-align: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme, disabled }) => (disabled ? 'transparent' : theme.colors.secondary)};
  }
`

export const FileName = styled.span`
  margin-top: 10px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primary};
  word-break: break-all;
`
